import { render, staticRenderFns } from "./ProjectEditExtraFields.vue?vue&type=template&id=3faaf60c"
import script from "./ProjectEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./ProjectEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3faaf60c')) {
      api.createRecord('3faaf60c', component.options)
    } else {
      api.reload('3faaf60c', component.options)
    }
    module.hot.accept("./ProjectEditExtraFields.vue?vue&type=template&id=3faaf60c", function () {
      api.rerender('3faaf60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectEditExtraFields.vue"
export default component.exports